import {CaretRight} from '@phosphor-icons/react'
import {useEffect, useState} from 'react'
import {useOccupancy} from '../../../../hooks/useOccupancy'
import {LayoutModel} from '../../../layout/models/layout.model'
import {KTableLoading} from '../../../../../../components/UI'
import {formatDateType4} from '../../../../../../util/dates'
import Calendar from '../calendar'
import {FormSubHeaderReportOccupancy} from '../Form/FormSubHeaderReportOccupancy'
import {getDailyGuestOccupancyList} from '../../../../services/report.service'
// import { useHoteleria } from '../../../../../../hooks/useHoteleria'
// import { TabModel } from '../../../../../../models'
// import {useDispatch, useSelector} from 'react-redux'
// import {AppStore} from '../redux/store'

const NodeTree = ({node, selectedOption, TipoDataIn, formValues}: any) => {
  const [isCampamentoExpanded, setIsCampamentoExpanded] = useState(false)
  const {reportData, getReportList, TipoData, getReportListHuesped} = useOccupancy()

  const [nodeIn, setNodeIn] = useState<LayoutModel | any>({})
  const handleCampamentoExpand = () => {
    setIsCampamentoExpanded(!isCampamentoExpanded)
    if (!isCampamentoExpanded) {
      if (TipoDataIn === 'CAP') {
        loadModulesLayout()
      } else if (TipoDataIn === 'MOD') {
        loadPisosLayout()
      } else if (TipoDataIn === 'PIS') {
        loadHabitationsLayout()
      } else if (TipoDataIn === 'HAB') {
        loadCamasayout()
      } else if (TipoDataIn === 'CAM') {
        loadHuespedesLayout()
      }
    }
  }

  const loadModulesLayout = () => {
    getReportList({
      TipoData: 'MOD',
      CompaniaId: selectedOption.CompaniaId,
      ClienteId: selectedOption.ClienteId,
      SiteId: selectedOption.SiteId,
      // CampamentoId: selectedOption.CampamentoId,
      FechaIni: formatDateType4(selectedOption.FechaDesde),
      FechaFin: formatDateType4(selectedOption.FechaHasta),
      CampamentoDetId: nodeIn.CampamentoId,
      HuespedDetId: formValues.HuespedDetId || '',
      ModuloId: formValues.ModuloId || '',
      HabitacionId: formValues.HabitacionId || '',
      CamaId: formValues.CamaId || '',
      EmpresaSubId: formValues.EmpresaId || '',
    })
  }

  const loadPisosLayout = () => {
    getReportList({
      TipoData: 'PIS',
      CompaniaId: selectedOption.CompaniaId,
      ClienteId: selectedOption.ClienteId,
      SiteId: selectedOption.SiteId,
      CampamentoId: selectedOption.CampamentoId,
      FechaIni: formatDateType4(selectedOption.FechaDesde),
      FechaFin: formatDateType4(selectedOption.FechaHasta),
      CampamentoDetId: nodeIn.CampamentoId,
      ModuloDetId: nodeIn.ModuloId,
      HuespedDetId: formValues.HuespedDetId,
      ModuloId: formValues.ModuloId || '',
      HabitacionId: formValues.HabitacionId || '',
      CamaId: formValues.CamaId || '',
      EmpresaSubId: formValues.EmpresaId || '',
    })
  }

  const loadHabitationsLayout = () => {
    getReportList({
      TipoData: 'HAB',
      CompaniaId: selectedOption.CompaniaId,
      ClienteId: selectedOption.ClienteId,
      SiteId: selectedOption.SiteId,
      CampamentoId: selectedOption.CampamentoId,
      FechaIni: formatDateType4(selectedOption.FechaDesde),
      FechaFin: formatDateType4(selectedOption.FechaHasta),
      CampamentoDetId: nodeIn.CampamentoId,
      ModuloDetId: nodeIn.ModuloId,
      PisoId: nodeIn.PisoId,
      HuespedDetId: formValues.HuespedDetId,
      ModuloId: formValues.ModuloId || '',
      HabitacionId: formValues.HabitacionId || '',
      CamaId: formValues.CamaId || '',
      EmpresaSubId: formValues.EmpresaId || '',
    })
  }

  const loadCamasayout = () => {
    getReportList({
      TipoData: 'CAM',
      CompaniaId: selectedOption.CompaniaId,
      ClienteId: selectedOption.ClienteId,
      SiteId: selectedOption.SiteId,
      CampamentoId: selectedOption.CampamentoId,
      FechaIni: formatDateType4(selectedOption.FechaDesde),
      FechaFin: formatDateType4(selectedOption.FechaHasta),
      CampamentoDetId: nodeIn.CampamentoId,
      ModuloDetId: nodeIn.ModuloId,
      PisoId: nodeIn.PisoId,
      HabitacionDetId: nodeIn.HabitacionId,
      HuespedDetId: formValues.HuespedDetId,
      ModuloId: formValues.ModuloId || '',
      HabitacionId: formValues.HabitacionId || '',
      CamaId: formValues.CamaId || '',
      EmpresaSubId: formValues.EmpresaId || '',
    })
  }
  const loadHuespedesLayout = async () => {
    await getReportListHuesped({
      CompaniaId: selectedOption.CompaniaId,
      ClienteId: selectedOption.ClienteId,
      SiteId: selectedOption.SiteId,
      CampamentoId: nodeIn.CampamentoId,
      ModuloId: nodeIn.ModuloId,
      HabitacionId: nodeIn.HabitacionId,
      CamaId: nodeIn.CamaId,
      HuespedId: selectedOption.HuespedDetId,
      EmpresaSubId: formValues.EmpresaId || '',
      FechaDesde: formatDateType4(selectedOption.FechaDesde) || '',
      FechaHasta: formatDateType4(selectedOption.FechaHasta) || '',
    })
  }
  useEffect(() => {
    if (!reportData || reportData.length === 0) return

    if (TipoData === 'MOD') {
      setNodeIn({...nodeIn, modules: reportData})
    }

    if (TipoData === 'PIS') {
      setNodeIn({...nodeIn, pisos: reportData})
    }

    if (TipoData === 'HAB') {
      setNodeIn({...nodeIn, habitaciones: reportData})
    }

    if (TipoData === 'CAM') {
      setNodeIn({...nodeIn, camas: reportData})
    }
    if (TipoData === 'HUE') {
      setNodeIn({...nodeIn, huespedes: reportData})
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [reportData])

  useEffect(() => {
    setNodeIn(node)
  }, [TipoDataIn])

  function getClassOpenTag() {
    if (TipoDataIn === 'MOD') {
      return 'btn-icon btn btn-active-light ms-1 me-1 w-30px h-30px rounded-circle p-0'
    } else if (TipoDataIn === 'PIS') {
      return 'btn-icon btn btn-active-light ms-3 me-3 w-30px h-30px rounded-circle p-0'
    } else if (TipoDataIn === 'HAB') {
      return 'btn-icon btn btn-active-light ms-5 me-5 w-30px h-30px rounded-circle p-0'
    } else if (TipoDataIn === 'CAM') {
      return 'btn-icon btn btn-active-light ms-7 me-7 w-30px h-30px rounded-circle p-0'
    } else if (TipoDataIn === 'HUE') {
      return 'btn-icon btn btn-active-light ms-7 me-7 display-none w-30px h-30px rounded-circle p-0'
    } else {
      return 'btn-icon btn btn-active-light me-1 w-30px h-30px rounded-circle p-0'
    }
  }
  return (
    <>
      <tr>
        <td colSpan={TipoDataIn === 'HUE' ? 4 : 1}>
          <button type='button' className={getClassOpenTag()} onClick={handleCampamentoExpand}>
            <CaretRight
              size={16}
              weight='bold'
              className={`${isCampamentoExpanded && 'animation-rotate-90'}`}
            />
          </button>
          {TipoDataIn === 'CAP' && (
            <span className={`${isCampamentoExpanded && 'fw-bold'}`}>
              {nodeIn.CampamentoNombre}
            </span>
          )}
          {TipoDataIn === 'MOD' && (
            <span className={`${isCampamentoExpanded && 'fw-bold'}`}>
              {nodeIn.NomenclaturaModulo}
            </span>
          )}
          {TipoDataIn === 'PIS' && (
            <span className={`${isCampamentoExpanded && 'fw-bold'}`}>{nodeIn.PisoNombre}</span>
          )}
          {TipoDataIn === 'HAB' && (
            <span className={`${isCampamentoExpanded && 'fw-bold'}`}>
              {nodeIn.NomenclaturaHabitacion}
            </span>
          )}
          {TipoDataIn === 'CAM' && (
            <span className={`${isCampamentoExpanded && 'fw-bold'}`}>
              {nodeIn.NomenclaturaCama}
            </span>
          )}
          {TipoDataIn === 'HUE' && (
            <span className='ms-10'>
              <b>N° Reserva: </b> {nodeIn.NroReserva ?? '-'}
            </span>
          )}
        </td>
        {TipoDataIn !== 'HUE' ? (
          <>
            <td>{nodeIn.TotalModulos}</td>
            <td>{nodeIn.TotalHabitaciones}</td>
            <td className={'border-gray-200'}>{TipoDataIn === 'CAM' ? '' : nodeIn.TotalCamas}</td>
            <td className={'border-gray-200'}>{nodeIn.TotalCamasCC}</td>
            <td className={'border-gray-200'} style={{borderRight: '1px solid black'}}>
              {nodeIn.TotalCamas2} {TipoDataIn === 'CAM' ? 'Personas' : ''}
            </td>
            <td>{nodeIn.TotalHabitacionesRES}</td>
            <td>{nodeIn.TotalHabitacionesOCU}</td>
            <td>
              {nodeIn.TotalCamasOCU} {TipoDataIn === 'CAM' ? 'Personas' : ''}
            </td>
            <td>
              {nodeIn.OcupacionHabitaciones !== null && nodeIn.OcupacionHabitaciones !== undefined
                ? `${(Number(nodeIn.OcupacionHabitaciones) * 100).toFixed(2)}%`
                : ''}
            </td>
            <td>
              {nodeIn.OcupacionCamas !== null && nodeIn.OcupacionCamas !== undefined
                ? `${(Number(nodeIn.OcupacionCamas) * 100).toFixed(2)}%`
                : ''}
            </td>
          </>
        ) : (
          <>
            <td colSpan={3} className={'border-gray-200'} style={{borderLeft: '1px solid black'}}>
              <span>
                <b>{nodeIn.HuespedTipoDocNombre ?? 'S/D'}: </b> {nodeIn.HuespedNroDoc ?? 'S/N'}
              </span>
            </td>
            <td
              colSpan={2}
              className={'border-gray-200'}
              style={{borderLeft: '1px solid black', borderRight: '1px solid black'}}
            >
              <span>
                <b>Empresa: </b> {nodeIn.HuespedEmpresaRuc} - {nodeIn.HuespedEmpresa}
              </span>
            </td>
          </>
        )}
      </tr>

      {isCampamentoExpanded && nodeIn.modules && TipoDataIn === 'CAP' && (
        <>
          {nodeIn.modules.map((module: any) => (
            <>
              <NodeTree
                key={TipoDataIn + '-' + node.ModuloId}
                selectedOption={selectedOption}
                node={module}
                TipoDataIn={'MOD'}
                formValues={formValues}
              />
            </>
          ))}
        </>
      )}

      {isCampamentoExpanded && nodeIn.pisos && TipoDataIn === 'MOD' && (
        <>
          {nodeIn.pisos.map((piso: any) => (
            <>
              <NodeTree
                key={node.PisoId}
                selectedOption={selectedOption}
                node={piso}
                TipoDataIn={'PIS'}
                formValues={formValues}
              />
            </>
          ))}
        </>
      )}

      {isCampamentoExpanded && nodeIn.habitaciones && TipoDataIn === 'PIS' && (
        <>
          {nodeIn.habitaciones.map((habitacion: any) => (
            <>
              <NodeTree
                key={node.HabitacionId}
                selectedOption={selectedOption}
                node={habitacion}
                TipoDataIn={'HAB'}
                formValues={formValues}
              />
            </>
          ))}
        </>
      )}

      {isCampamentoExpanded && nodeIn.camas && TipoDataIn === 'HAB' && (
        <>
          {nodeIn.camas.map((cama: any) => (
            <>
              <NodeTree
                key={node.CamaId}
                selectedOption={selectedOption}
                node={cama}
                TipoDataIn={'CAM'}
                formValues={formValues}
              />
            </>
          ))}
        </>
      )}

      {isCampamentoExpanded && nodeIn.huespedes && TipoDataIn === 'CAM' && (
        <>
          {nodeIn.huespedes.map((huesped: any) => (
            <>
              <NodeTree
                key={node.HuespedId}
                selectedOption={selectedOption}
                node={huesped}
                TipoDataIn={'HUE'}
                formValues={formValues}
              />
            </>
          ))}
        </>
      )}
    </>
  )
}

export const TableReportOccupancy = ({
  selectedOption,
  setChangeDate,
  changeDate,
  showSearch,
  setIsSearchEmp,
  setIdEmpresa,
}: any) => {
  const [nodes, setNodes] = useState([])

  const {TipoData, setTipoData, getReportList, reportData} = useOccupancy()
  const [searching, setSearching] = useState(false)
  const [hasDataReport, setHasDataReport] = useState<boolean>(false)
  const [hasDataCalendar, setHasDataCalendar] = useState<boolean>(false)
  const [fechas, setFechas] = useState<any>({desde: '', hasta: ''})
  const [formValue, setFormValue] = useState<any>([])
  const [fechasEstadia, setFechasEstadia] = useState<any>([])

  const getDaysGuestCalendar = async (huesped: any) => {
    setHasDataCalendar(false)
    const dailyData = await getDailyGuestOccupancyList({
      CampamentoId: selectedOption.CampamentoId,
      SiteId: selectedOption.SiteId || '',
      HuespedDetId: huesped || '',
      FechaInicio: formatDateType4(selectedOption.FechaDesde),
      FechaFin: formatDateType4(selectedOption.FechaHasta),
    })

    if (dailyData.data && dailyData.data.length > 0) {
      let fechasArray = Array.from(
        new Set(
          dailyData.data
            .filter(({NroEstadias}: any) => NroEstadias !== 0)
            .map(({FechaEstadia}: any) => new Date(FechaEstadia).getUTCDate()),
        ),
      )
      setHasDataCalendar(true)
      setFechasEstadia(fechasArray)
    }
  }
  const onSubmit = (data: any) => {
    let TipoDataIn = 'CAP'
    setSearching(true)
    setHasDataReport(false)
    setFormValue(data)
    setTipoData(TipoDataIn)
    getDaysGuestCalendar(data.HuespedDetId || '')
    getReportList({
      TipoData: TipoDataIn,
      CompaniaId: selectedOption.CompaniaId,
      ClienteId: selectedOption.ClienteId,
      SiteId: selectedOption.SiteId,
      CampamentoId: selectedOption.CampamentoId,
      FechaIni: formatDateType4(selectedOption.FechaDesde),
      FechaFin: formatDateType4(selectedOption.FechaHasta),
      HuespedDetId: data.HuespedDetId || '',
      ModuloDetId: data.ModuloId || '',
      HabitacionDetId: data.HabitacionId || '',
      CamaDetId: data.CamaId || '',
      EmpresaSubId: data.EmpresaId || '',
    })
  }

  useEffect(() => {
    if (changeDate) {
      setChangeDate(false)
      setTipoData('')
      setHasDataCalendar(false)
      setHasDataReport(false)
      setNodes([])
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [changeDate])

  useEffect(() => {
    setSearching(false)
    if (!reportData || reportData.length === 0) return
    if (TipoData === 'CAP') {
      setNodes(reportData)
      setHasDataReport(true)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [reportData])

  return (
    <div className='p-6'>
      <div className='p-2'>
        {showSearch && (
          <FormSubHeaderReportOccupancy
            submitFn={onSubmit}
            setFechas={setFechas}
            setSearching={setSearching}
            selectedOption={selectedOption}
            setHasDataReport={setHasDataReport}
            setIsSearchEmp={setIsSearchEmp}
            setIdEmpresa={setIdEmpresa}
          />
        )}
      </div>
      {searching && (
        <div className='position-relative h-100px'>
          <KTableLoading />
        </div>
      )}
      {hasDataCalendar && <Calendar fechas={fechas} fechasEstadia={fechasEstadia} />}
      {hasDataReport && (
        <div className='card card-custom'>
          <div className='card-body'>
            <div className='table-responsive'>
              <table className='table gs-7 gy-7 gx-7 table-row-bordered table-report-occupancy'>
                <thead>
                  <tr>
                    <th
                      rowSpan={2}
                      className={
                        'fw-bold fs-6 text-center text-gray-800 border-bottom border-gray-200'
                      }
                      style={{minWidth: '200px', borderRight: '1px solid black'}}
                    >
                      Nombre
                    </th>
                    <th
                      colSpan={5}
                      className={
                        'fw-bold fs-6 text-center text-gray-800 border-bottom border-gray-200'
                      }
                      style={{borderRight: '1px solid black'}}
                    >
                      TOTALES
                    </th>
                    <th
                      colSpan={3}
                      className={
                        'fw-bold fs-6 text-center text-gray-800 border-bottom border-gray-200'
                      }
                      style={{borderRight: '1px solid black'}}
                    >
                      DATOS
                    </th>
                    <th
                      colSpan={2}
                      className={
                        'fw-bold fs-6 text-center text-gray-800 border-bottom border-gray-200'
                      }
                    >
                      OCUPACIÓN
                    </th>
                  </tr>
                  <tr className='fw-bold fs-6 text-gray-800 border-bottom border-gray-200'>
                    <th>Módulos</th>
                    <th>Habitaciones</th>
                    <th className={'border-gray-200'} style={{borderRight: '1px solid black'}}>
                      Camas Instaladas
                    </th>
                    <th className={'border-gray-200'} style={{borderRight: '1px solid black'}}>
                      Camas Calientes
                    </th>
                    <th className={'border-gray-200'} style={{borderRight: '1px solid black'}}>
                      Camas Totales (C.I + C.C)
                    </th>
                    <th>Hbt. Reservadas</th>
                    <th>Hbt. Ocupadas</th>
                    <th>Camas Ocupadas</th>
                    <th>% Ocup. Hbt.</th>
                    <th>% Ocup. Camas</th>
                  </tr>
                </thead>
                <tbody>
                  {nodes.map((node: any) => (
                    <NodeTree
                      key={node.CampamentoId}
                      selectedOption={{...selectedOption, ...formValue}}
                      node={node}
                      formValues={formValue}
                      TipoDataIn={'CAP'}
                    />
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      )}
    </div>
  )
}
